export const INACTIVE_REASON_EXPLANATION_MAX_LENGTH = 1000;

export const requiresInactiveReasonConfirmation = (transition) =>
    transition?.inactiveReasonConfirmationRequired === true;

export const getInactiveConfirmationKey = (transition) =>
    `${transition?.clientId || "unknown"}:${transition?.inactiveSince || "unknown"}`;

export const getClientTypeLabel = (clientType) =>
    String(clientType || "").trim().toUpperCase() === "BUSINESS"
        ? "Business"
        : "Individual";

export const buildInactiveReasonConfirmationPayload = (
    transition,
    stillClient,
    explanation,
) => ({
    inactiveSince: transition.inactiveSince,
    stillClient,
    explanation: stillClient ? null : explanation.trim(),
});

export const getConfirmedInactiveClientState = (confirmationResult) => {
    if (
        confirmationResult?.status !== "confirmed" &&
        confirmationResult?.status !== "stale-resolved"
    ) {
        return null;
    }

    const data = confirmationResult?.data;
    const clientId = data?.clientId ?? data?.ClientId ?? data?.id ?? data?.Id;
    const inactiveReason = data?.inactiveReason ?? data?.InactiveReason;
    const isActive = data?.isActive ?? data?.IsActive;

    if (!clientId || typeof inactiveReason !== "string") return null;

    return {
        clientId,
        isActive: isActive ?? false,
        inactiveReason,
    };
};

export const mergeConfirmedInactiveClientState = (client, confirmedState) => {
    if (
        !client ||
        !confirmedState ||
        String(client.id ?? client.Id) !== String(confirmedState.clientId)
    ) {
        return client;
    }

    return {
        ...client,
        isActive: confirmedState.isActive,
        inactiveReason: confirmedState.inactiveReason,
    };
};
